export default __webpack_public_path__ + "static/jackpotHome-a40b4c1f6920c85d75ff01a2b202539b.png";